<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_provider") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <v-row>
            <v-row class="mb-5">
              <base-image-upload-input
                col="6"
                identifier="logo"
                :placeholder="$t('PLACEHOLDERS.store_logo')"
                @selectImage="selectImageStore"
                required
              />
              <base-image-upload-input
                col="6"
                identifier="commercial_register_image"
                :placeholder="$t('PLACEHOLDERS.commercial_register')"
                @selectImage="selectImageCR"
                required
              />
            </v-row>
          </v-row>
          <v-row>
            <v-col cols="12">
              <UploadsPhotos
                :urls="imgUrls"
                multiple
                @onFileSelect="onFileSelect"
                @onFileRemove="onFileRemove"
              >
                {{ $t("PLACEHOLDERS.store_images") }}
                <span class="text-danger">*</span>
              </UploadsPhotos>
            </v-col>
          </v-row>
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.providerName')"
            v-model.trim="data.name"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.mobile"
            required
          />
          <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            required
          />
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          />
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.store_name_ar')"
            v-model.trim="data.store_name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.store_name_fr')"
            v-model.trim="data.store_name_fr"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.description_ar"
            required
          />

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.description_fr"
            required
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.estimated_preparation_time')"
            v-model.trim="data.preparation_time"
            required
          />

          <base-select-input
            col="6"
            :optionsList="categories"
            :placeholder="$t('PLACEHOLDERS.storeCat')"
            v-model="data.store_category"
            required
          />

          <base-select-input
            col="6"
            :optionsList="banks"
            :placeholder="$t('PLACEHOLDERS.bank_name')"
            v-model="data.bank_name"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bank_num')"
            v-model.trim="data.bank_account"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_register')"
            v-model.trim="data.commercial_register"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.iban')"
            v-model.trim="data.iban"
            required
          />
          <div class="row">
            <p class="font-weight-bold mx-4" style="color: #F7941E">
              {{ $t("PLACEHOLDERS.work_hours") }}
            </p>
            <div v-if="data.work_hours.length == 0" class="text-center">
              <h5 class="my-5 mx-2 d-inline">{{ $t("TABLES.noData") }}</h5>
              <button type="button" @click="addWorkDay">
                <i
                  class="fas fa-plus-circle"
                  :class="{ disabled_button: data.work_hours.length == 7 }"
                  style="font-size: 20px; color: #007bff"
                ></i>
              </button>
            </div>
            <div
              v-for="(element, index) in data.work_hours"
              :key="index"
              class="row"
            >
              <base-select-input
                col="3"
                :optionsList="filteredDays"
                :placeholder="$t('PLACEHOLDERS.day')"
                v-model="element.day_id"
              />
              <base-input
                col="3"
                type="time"
                :placeholder="$t('TABLES.ImagesSpaces.start_time')"
                v-model.trim="element.start_time"
              />
              <base-input
                col="3"
                type="time"
                :placeholder="$t('TABLES.ImagesSpaces.end_time')"
                v-model.trim="element.end_time"
              />
              <div class="col-3 mt-5 pt-5">
                <button
                  v-if="data.work_hours.length > 1"
                  type="button"
                  @click="removeWorkDay(element.day_id?.id, index)"
                >
                  <i
                    class="fas fa-minus-circle"
                    style="font-size: 20px; color: #007bff; margin-left: 5px"
                  ></i>
                </button>
                <button
                  type="button"
                  @click="addWorkDay"
                  v-if="index === data.work_hours.length - 1"
                  :disabled="data.work_hours.length == 7"
                >
                  <i
                    class="fas fa-plus-circle"
                    :class="{ disabled_button: data.work_hours.length == 7 }"
                    style="font-size: 20px; color: #007bff"
                  ></i>
                </button>
              </div>
            </div>
          </div>
          <hr style="width: 98%" class="my-5" />
          <h5 class="font-weight-bold" style="color: #F7941E">
            {{ $t("PLACEHOLDERS.address") }}
          </h5>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model.trim="data.area"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.street')"
            v-model.trim="data.street"
            required
          />
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.building')"
            v-model.trim="data.building"
            required
          />
          <p class="mb-5 px-3" style="color: #F7941E; font-size: 16px">
            {{ $t("PLACEHOLDERS.location_on_map")
            }}<span class="text-danger"> * </span>
          </p>
          <ChangableMapComponent
            :lat="parseFloat(data.latitude)"
            :lng="parseFloat(data.longitude)"
            @update:lat="data.latitude = $event"
            @update:lng="data.longitude = $event"
            @update:placeName="data.address = $event"
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-5"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import UploadsPhotos from "@/components/formInputs/UploadsPhotos.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  components: { UploadsPhotos, ChangableMapComponent },
  data() {
    return {
      isWaitingRequest: false,
      data: {
        work_hours: [
          {
            // id : null,
            day_id: { id: null, name: null },
            start_time: null,
            end_time: null,
            // created_at:null
          },
        ],
        dayMappingToEnglish: {
          الأحد: "Sunday",
          الاثنين: "Monday",
          الثلاثاء: "Tuesday",
          الأربعاء: "Wednesday",
          الخميس: "Thursday",
          الجمعة: "Friday",
          السبت: "Saturday",
        },
        logo: { path: "", file: "" },
        commercial_register_image: { path: "", file: "" },
        commercial_register: "",
        name: "",
        store_name_ar: "",
        store_name_fr: "",
        mobile: "",
        email: "",
        password: "",
        passwordConfirmation: "",
        description_ar: "",
        description_fr: "",
        preparation_time: "",
        store_category: null,
        latitude: 18.0735,
        longitude: -15.9582,
        area: "",
        city: "",
        district: "",
        street: "",
        building: "",
        bank_name: "",
        bank_account: "",
        iban: "",
        address: "",
      },
      imgUrls: [],
      store_categories: [],
      categories: [],
      banks: [],
    };
  },
  computed: {
    dayMapping() {
      return {
        السبت: { id: 1, name: this.$t("days.Saturday") },
        الأحد: { id: 2, name: this.$t("days.Sunday") },
        الاثنين: { id: 3, name: this.$t("days.Monday") },
        الثلاثاء: { id: 4, name: this.$t("days.Tuesday") },
        الأربعاء: { id: 5, name: this.$t("days.Wednesday") },
        الخميس: { id: 6, name: this.$t("days.Thursday") },
        الجمعة: { id: 7, name: this.$t("days.Friday") },
      };
    },
    filteredDays() {
      const usedDays = new Set(
        this.data.work_hours.map((workHour) => workHour.day_id?.id)
      );
      const usedDaysNames = new Set(
        this.data.work_hours.map((workHour) => workHour.day_id?.name)
      );
      console.log("1111", usedDays);
      console.log("2222", Object.values(this.dayMapping));
      return Object.values(this.dayMapping).filter(
        (day) => !usedDaysNames.has(day.name)
      );
    },
  },
  methods: {
    addWorkDay() {
      this.data.work_hours.push({
        day_id: null,
        start_time: null,
        end_time: null,
      });
    },

    async removeWorkDay(index, item_index) {
      if (this.data.work_hours.length > 0) {
        this.data.work_hours.splice(item_index, 1);
      } else {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.errors.message[0]);
      }
    },
    selectImageStore(selectedImage) {
      this.data.logo = selectedImage;
    },
    selectImageCR(selectedImage) {
      this.data.commercial_register_image = selectedImage;
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const formData = new FormData();
      formData.append("logo", this.data.logo.file);
      formData.append(
        "commercial_register_image",
        this.data.commercial_register_image.file
      );
      console.log("this.imgUrls", this.imgUrls);
      let index = 0;
      for (let img in this.additionalImages) {
        formData.append(`images[${index}]`, this.additionalImages[index]);
        index++;
      }
      formData.append("name", this.data.name);
      formData.append("store_name[ar]", this.data.store_name_ar);
      formData.append("store_name[fr]", this.data.store_name_fr);
      formData.append("mobile", this.data.mobile);
      formData.append("email", this.data.email);
      formData.append("description[ar]", this.data.description_ar);
      formData.append("description[fr]", this.data.description_fr);
      formData.append("preparation_time", this.data.preparation_time);
      formData.append("longitude", this.data.longitude);
      formData.append("latitude", this.data.latitude);
      formData.append("area", this.data.area);
      formData.append("city", this.data.city);
      formData.append("district", this.data.district);
      formData.append("street", this.data.street);
      formData.append("build", this.data.building);
      formData.append("account_number", this.data.bank_account);
      formData.append("commercial_register", this.data.commercial_register);
      formData.append("iban", this.data.iban);
      formData.append("password", this.data.password);
      formData.append("password_confirmation", this.data.passwordConfirmation);
      formData.append("bank_id", this.data.bank_name?.id);
      formData.append("category_id", this.data.store_category?.id);
      this.data.work_hours.forEach((workHour, index) => {
        const arabicDayName =
          workHour.day_id && workHour.day_id.name ? workHour.day_id.name : null;
        const englishDayName = arabicDayName
          ? this.data.dayMappingToEnglish[arabicDayName]
          : null;

        if (!englishDayName) {
          // If no match is found in dayMappingToEnglish, use arabicDayName directly
          console.warn(
            `No English translation found for day: ${arabicDayName}`
          );
        }
        if (workHour.day_id.id != null) {
          formData.append(`work_hour[${index}][day]`, workHour.day_id.id);
        }
        if (workHour.start_time != null) {
          formData.append(`work_hour[${index}][from]`, workHour.start_time);
        }
        if (workHour.end_time != null) {
          formData.append(`work_hour[${index}][to]`, workHour.end_time);
        }
      });

      try {
        await this.$axios.post("/providers", formData);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push("/providers/all");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories?page=0&limit=0`,
          params: {
            is_active: 1,
            page: 0,
            limit: 0,
          },
        });
        this.categories = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getBanks() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `banks?page=0&limit=0`,
          params: {
            is_active: 1,
            page: 0,
            limit: 0,
          },
        });
        this.banks = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },
  mounted() {
    this.getCategories();
    this.getBanks();
  },
};
</script>
